export default {
    courseStatuses: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/courseStatus/state.js